import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { PublisherService } from '../../core/services/publisher.service';
import { OverlayContainer } from '@angular/cdk/overlay';
import { HelpComponent } from '../help/help.component';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { UserProperty, Regex, CacheConstant, CacheDuration, CMSPages } from '../../core/constants/app.constant';
import { TypeRefs } from '../../shared/models/static-data';
import { AuthService } from '../../core/services/auth.service';
import {
  AppConfigService as AppConfig,
  Configuration
} from '../../core/services/init/app-config.service';
import {
  OktaRoutes,
  RoutePrefix,
  ProductRoutes,
  AEMRoutes,
  OrderRoutes,
  TrackAndTraceRoutes
} from '../../core/constants/routes.constant';
import { StaticConstants } from '../../core/constants/static.constants';
import { AppUtilService } from '../../core/utils/app-util.service';

import { UserService } from '../../core/services/user.service';
import { GoogleAnalyticsService } from '../../core/services/google-analytics.service';

import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { StaticContentService } from '../../modules/static-content/static-content.service';
import { UntypedFormControl } from '@angular/forms';
import { ProductsService } from '../../modules/products/products.service';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { AppCacheService } from '../../core/services/cache/app-cache.service';
import { MatLegacyMenuTrigger as MatMenuTrigger } from '@angular/material/legacy-menu';
import { CmsService } from '../../core/services/cms.service';
import { CmsContent, CmsContentField, MultipleCarousel, StaticPageContent } from '../../shared/models/cms';
import { PurchaseHistoryComponent } from '../../modules/products/purchase-history/purchase-history.component';
import { DatePipe } from '@angular/common'; 
@Component({
  selector: 'par-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit, OnDestroy {
  /***************Properties***************/
  shopMenu: MatMenuTrigger;
  authContent: any;
  cmsPageName: any;
  templateNum: any;
  recordList: any;
 
  presentDate:string = '';
  previousDString:string = '';
  ifDatePresent : boolean = false;
  previousDate: Date;



  @ViewChild(MatMenuTrigger, { static: false }) set content(content: MatMenuTrigger) {
    this.shopMenu = content;
  }
  private theme = this.config.get(Configuration.PARMED_THEME);
  private authSubscription: Subscription = null;
  private cartCountSubscription: Subscription = null;
  envProperties = this.cache.get(CacheConstant.Env_Properties);
  elasticSearchFlag: boolean = this.envProperties.elasticSearchFlag ? this.envProperties.elasticSearchFlag.toBoolean() : false;
  isSubscriptionEnabled: boolean = this.envProperties.subscriptionEnabled;
  websiteName: string = this.envProperties.theme;
  isUnauthSearchEnabled: boolean=this.envProperties.unauthSearchEnabled;
  isParmedCategoriesFlag: boolean=this.envProperties.parmedCategoriesFlag;
  enableCsosItems:  boolean=this.envProperties.enableCsosItems;

  routes = {
    forgotPassword: OktaRoutes.ForgotPassword,
    contactUs: RoutePrefix.ContactUs,
    register: RoutePrefix.Register,
    changeSecurityChallenge: OktaRoutes.UpdateSecurityQuestion,
    changePassword: OktaRoutes.ChangePassword,
    creditCards: RoutePrefix.CreditCards,
    home: RoutePrefix.Home,
    myhome: RoutePrefix.MyHome,
    aboutus: AEMRoutes.AboutUs,
    majorAboutUs: AEMRoutes.MajorAboutUS,
    myaccount: AEMRoutes.MyAccount,
    shop: AEMRoutes.Shop,
    productServices: AEMRoutes.ProductServices,
    packageInsert: RoutePrefix.PackageInsert,
    harvardURL: this.envProperties.harvardUrl,
    favorites: ProductRoutes.Favorites,
    payInvoices: OrderRoutes.PayInvoice,
    watchList: ProductRoutes.WatchList,
    searchTransactionData: '/' + TrackAndTraceRoutes.SearchTransactionData,
    dscsaReporting: '/' + TrackAndTraceRoutes.DscsaReporting,
    csosOrderHistory: '/' + OrderRoutes.CsosOrderHistory,
    customerForms: AEMRoutes.CustomerForms,
    csosRegistration: this.envProperties.axWayRegisterUrl,
    quickOrder: OrderRoutes.QuickOrder,
    producthistory: ProductRoutes.ProductHistory,
    majorproductservices: AEMRoutes.MajorProductServices,
    productCatalog: ProductRoutes.ProductCatalog,
    productCatalogList:AEMRoutes.Major.ProductCatalogList,

    dispill: ProductRoutes.Dispill,
    promotions: ProductRoutes.Promotions,
    categories: ProductRoutes.Categories,
    categoryDetails: ProductRoutes.Category_Detail,
    promotionDetails: ProductRoutes.Promotions_Detail,
    subscription: ProductRoutes.Subscription,
    fullCatalog: ProductRoutes.Product_Search,
    orderHistory:OrderRoutes.OrderHistory,
    productReturn:ProductRoutes.ProductReturn,
    majorAmazon:RoutePrefix.Amazon,
    majorNews: AEMRoutes.Major.News,
  };
  orderCount = -1;
  isAuthenticated = false;
  searchProduct: UntypedFormControl = new UntypedFormControl();
  searchOptions: Array<TypeRefs> = new Array<TypeRefs>();
  advanceSearchOptions: Array<TypeRefs> = new Array<TypeRefs>();
  advanceSearchOperandOptions: Array<TypeRefs> = new Array<TypeRefs>();
  lookerReportEffectiveDate = this.envProperties.lookerReportEffectiveDate;

  search = {
    type: null,
    option: null,
    operand: null,
    value: null,
    isAdvance: null
  };

 
  searchType: TypeRefs;
  advancedSearchOption: TypeRefs;
  operandType: TypeRefs;
  harvardFlg: boolean;
  productCatlogs = {
    show: false,
    catalogs: []
  };

  productSuggestions: [];
  promotions = [];
  subscriptions = [];

  hasCategories: boolean;
  categories = [];
  productcatalog: any;
  @Input() chatAvailable;
  @Input() chatEnable;
  @Output() onChatClick = new EventEmitter<any>();

  @Input() expertMedFlg;
  hasPromotions: boolean = false;
  /***************Properties***************/

  /***************Constructor***************/
  constructor(
    private cache: AppCacheService,
    public dialog: MatDialog,
    private authService: AuthService,
    private overlayContainer: OverlayContainer,
    private config: AppConfig,
    private userService: UserService,
    private gAnalytics: GoogleAnalyticsService,
    private staticContentService: StaticContentService,
    private cmsService: CmsService,
    private productService: ProductsService,
    private router: Router,
    private datePipe: DatePipe
  ) {

  }

  ngOnInit() {

    this.searchProduct.valueChanges.pipe(debounceTime(200)).pipe(distinctUntilChanged()).subscribe((productName: any) => {
      // productName = productName.replace(/^\s+/g,'');
      if (productName != null && productName.length > 2 && productName.indexOf(' ') === -1) {

        if (this.productSuggestions && this.productSuggestions.some((item) => item == productName)) {
          return;
        }
        this.productService.searchProductTypeForward(productName)
          .subscribe((response: any) => {
            if (!response.hasError) {
              this.productSuggestions = this.elasticSearchFlag ? response.suggestions : response;
            }
          }
          )
      } else {
        this.productSuggestions = [];
      }
    });

    this.setDefaults();
    this.overlayContainer.getContainerElement().classList.add(this.theme);

    this.authSubscription = PublisherService.isAuthChanged$.subscribe(
      isAuthenticated => {
        this.onAuthenticationChange();
      }
    );

    this.cartCountSubscription = PublisherService.cartCountUpdated$.subscribe(
      count => this.onCartCountUpdate(count)
    );
    if (this.envProperties.theme === 'Major') {
      this.getCmsContent();
    }
     let lookerReportDate = new Date(this.lookerReportEffectiveDate);
     const today = new Date();
     if(lookerReportDate <= today){
       this.lookerReportEffectiveDate = this.datePipe.transform( this.lookerReportEffectiveDate , 'MM/dd/yyyy');
       var temp = new Date(this.lookerReportEffectiveDate );
       temp.setDate(temp.getDate() - 1);
       this.previousDate = temp;
       this.previousDString = this.datePipe.transform(this.previousDate, 'MM/dd/yyyy');
       this.ifDatePresent = true;
    }
  }

  getPromotion() {
    this.hasPromotions = false;
    this.userService.getPromotions(this.envProperties.buId).subscribe(res => {
      this.promotions = res;
      if (this.promotions.length) {
        this.hasPromotions = true;
        this.promotions.sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : ((b.name.toLowerCase() > a.name.toLowerCase()) ? -1 : 0));
      }
    });
  }
  getParmedCategories() {
    this.hasCategories = false;
    this.userService.getParmedCategories(this.envProperties.buId).subscribe(res => {
      this.categories = res;
      if (this.categories.length) {
        this.hasCategories = true;
        this.categories.sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : ((b.name.toLowerCase() > a.name.toLowerCase()) ? -1 : 0));
      }
    });
  }
reload(){
  window.location.reload();
}
  getCategories() {
    if(this.envProperties.buId==1){
      this.getParmedCategories();
    }
    else if(this.envProperties.buId==2){
    this.hasCategories = false;
    this.productService.getCategories().subscribe(res => {
      this.categories = res;
      this.hasCategories = true;
    });
  }
  }
  openDialog(){
     const dialogRef:MatDialogRef<PurchaseHistoryComponent>  = this.dialog.open(PurchaseHistoryComponent, {
       data:'price changes alert',
     width: '100%',
     height:'600px'
   });
     dialogRef.afterClosed().subscribe(result => {
     });
  }
  routeClick(route){
    if(route==this.routes.fullCatalog){
      this.router.navigate([route], { queryParams: { catalog: 'product-catalog' }});
    }
    else{
    this.router.navigate([route]);
   }
  if(this.router.url=='/'+route ||this.router.url==route ||this.router.url=='/'+route +'?catalog=product-catalog' ){
    this.reload()
  }
}

  ngOnDestroy() {
    this.authSubscription.unsubscribe();
    this.cartCountSubscription.unsubscribe();
  }
  /***************Constructor***************/

  /***************Component Methods***************/
  onOrderHistoryClick() {
    AppUtilService.router.navigate(['order/history']);
  }
  onBillerDirectClick() {
    const isCustomerAsscociationExists = this.userService.isAssociationExists();
    const UserCustomerRef = isCustomerAsscociationExists?.userCustomerXrefs
    if (UserCustomerRef.length > 0) {
      window.open(this.envProperties.billerDirectUrl, '_blank');
    }
    else {
      AppUtilService.redirectToHome();
    }
  }
  onCsosSignCertificateClick() {
    window.open(this.envProperties.axWayRegisterUrl, '_blank');
  }

  onExpertMedClick() {
    window.open(this.envProperties.expertMedUrl, '_blank');
  }

  onPromotionClick(promotion: any) {
    if (this.config.gTrackingId) {
      this.gAnalytics.logPromotionClick(promotion);
    }
    //this.router.navigate([this.routes.promotionDetails + promotion.categoryId]);
  }
  onSignInClick() {
    PublisherService.notifySignInRequest(null);
  }

  onRecentlyLaunchedGenericsClick() {
    this.productCatlogs.catalogs.forEach((catalog) => {
      if (catalog.label == "Recently Launched Generics") {
        AppUtilService.cache.set(
          CacheConstant.Catalog_Data,
          catalog,
          CacheDuration.OneHour
        );
        AppUtilService.router.navigate([ProductRoutes.ProductCatalog]);
        if(this.router.url=='/'+ProductRoutes.ProductCatalog){
          this.reload()
        }
      }
    })
  }

  onSearchTypeChange(searchType: TypeRefs) {
    this.search.isAdvance =
      searchType.typeCode === StaticConstants.TypeRef.AdvanceSearch;

    if (this.search.isAdvance) {
      this.search.option = this.advanceSearchOptions[0];
      this.search.operand = this.advanceSearchOperandOptions[0];
    }
  }

  onSearchCriteriaChange(searchCriteria: TypeRefs) {
    if (
      searchCriteria.typeCode ===
      StaticConstants.TypeRef.AdvanceSearchBasicOption
    ) {
      this.search.isAdvance = false;
    } else {
      this.search.option = searchCriteria;
    }
  }

  onSearchOperatorChange(searchOperator: TypeRefs) {
    this.search.operand = searchOperator;
  }

  onSearchChange() {
    if (this.searchProduct.value) {
      setTimeout(() => {
        this.searchProduct.value.replace(
          Regex.RestrictSpecialChars,
          ''
        );
      }, 50);
    }
  }

  onSearchProductSubmit() {
    let searchUrl = ProductRoutes.BasicSearch + '/';
    let advanceOption = null;
    let advanceOperand = null;

    if (this.search.isAdvance) {
      advanceOption = this.search.option.typeDesc.slugify();
      advanceOperand = this.search.operand.typeDesc.slugify();

      searchUrl =
        ProductRoutes.AdvanceSearch +
        '/' +
        advanceOption +
        '/' +
        advanceOperand +
        '/';
    }
    searchUrl =
      // searchUrl + (this.search.value ? this.search.value.encode() : '');
      searchUrl + (this.searchProduct.value ? this.searchProduct.value.encode() : '');
    if (this.config.gTrackingId) {
      this.gAnalytics.logSearch(this.searchProduct.value);
    }
    AppUtilService.router.navigate([searchUrl]);

    if (this.router.url === '/' + searchUrl) {
      if (this.config.gTrackingId) {
        this.gAnalytics.logSearch(this.searchProduct.value);
      }
      PublisherService.notifySearchTrigger({
        // searchVal: this.search.value,
        searchVal: this.searchProduct.value,
        advSearchType: advanceOption,
        advSearchFilter: advanceOperand
      });
    }

    // this.search.value = '';
    this.searchProduct.setValue('');
  }

  onProductHelpClick(): void {
    this.dialog.open(HelpComponent, {});
  }

  onInitiateChatClick() {
    this.onChatClick.emit();
  }
  /***************Component Methods***************/

  /******************Private Methods******************/

  private getProductCatalogsForShop() {
    this.staticContentService.getProductCatalog().subscribe((res: any) => {
      if (!res.hasError) {
        this.productCatlogs.show = true;
        this.productCatlogs.catalogs = res;
      }
    });
  }

  private setDefaults() {
    this.isAuthenticated = this.authService.isAuthenticated();
    this.validateHarvardFlag();
    this.setSearchOptions();
    if (this.isAuthenticated) {
      this.getProductCatalogsForShop();
    };
  }

  private setSearchOptions() {
    if (this.isAuthenticated) {
      this.searchOptions = AppUtilService.static.typeRef.byGroup(
        StaticConstants.TypeGroup.ProductSearchOptions
      );
      this.advanceSearchOptions = AppUtilService.static.typeRef.byGroup(
        StaticConstants.TypeGroup.AdvanceSearchOptions
      );
      this.advanceSearchOperandOptions = AppUtilService.static.typeRef.byGroup(
        StaticConstants.TypeGroup.AdvanceSearchOperand
      );

      this.search.isAdvance = false;
      this.search.type = this.searchOptions[0];
    }
  }

  private onAuthenticationChange() {
    this.setDefaults();
  }

  private onCartCountUpdate(orderCount: any) {
    this.orderCount = orderCount;
  }

  private validateHarvardFlag() {
    this.harvardFlg = this.userService.getProperty(UserProperty.HarvardFlg);
    this.routes.myaccount = this.harvardFlg
      ? AEMRoutes.MyAccountHarvard
      : AEMRoutes.MyAccount;
  }
  downloadFile() {

    let documentNum = this.authContent.recordList[0].documentNum;
    this.cmsService.getCmsMediaByDocNum(documentNum).subscribe((res: any) => {
      AppUtilService.redirectToExternalLink(res.mediaLink);

    })
  }

  getCmsContent() {
    this.cmsPageName = this.isAuthenticated ? CMSPages.Home : CMSPages.Login;
    this.templateNum = this.envProperties.cmsPageConfigVO.staticPageTemplateId;
    let pageSeqNumber = this.isAuthenticated ? this.envProperties.cmsPageConfigVO.productCatalogAuthenticatedSeqNo : this.envProperties.cmsPageConfigVO.productCatalogUnauthenticatedSeqNo;
    this.cmsService.getCmsStaticPageTemplateByPageNameAndTemplateNum(this.cmsPageName, this.envProperties.buId, this.templateNum, pageSeqNumber).subscribe((response: any) => {

      if (!response.hasError && response.length > 0) {
        let staticPageContent: StaticPageContent = response[0];
        this.authContent = JSON.parse(staticPageContent.contentStructure);
        let businessManagedAlert = this.cmsService.prepareNotificMsg(staticPageContent);
        // this.downloadFile();
      }
    });
  }

  /******************Private Methods******************/

}

